import { useEffect, useState } from 'react';
import { useAuthStore } from '@features/authentication/store/authStore';
import { authService } from '@features/authentication/services';
import { tokenService } from '@features/authentication/services/tokenService';
import { refreshAccessToken } from '@shared/api/apiClient';
import { useLogoutSync } from '@/hooks/useLogoutSync';

interface AuthInitializerProps {
  children: React.ReactNode;
}

export function AuthInitializer({ children }: AuthInitializerProps) {
  const [isReady, setIsReady] = useState(false);
  const fetchCurrentUser = useAuthStore((s) => s.fetchCurrentUser);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  useLogoutSync();

  useEffect(() => {
    const init = async () => {
      if (isAuthenticated && authService.isAuthenticated()) {
        await fetchCurrentUser();
      } else if (isAuthenticated && !authService.isAuthenticated()) {
        // Token expired — attempt refresh before clearing session
        const refreshToken = tokenService.getRefreshToken();
        if (refreshToken) {
          try {
            await refreshAccessToken();
            await fetchCurrentUser();
          } catch {
            useAuthStore.setState({ user: null, isAuthenticated: false });
          }
        } else {
          useAuthStore.setState({ user: null, isAuthenticated: false });
        }
      }
      setIsReady(true);
    };

    init();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!isReady) {
    return null;
  }

  return <>{children}</>;
}
